export var DocumentKeyEnum;
(function (DocumentKeyEnum) {
    DocumentKeyEnum["Notify"] = "__NotifyHelper__";
    DocumentKeyEnum["Modal"] = "__ModalHelper__";
})(DocumentKeyEnum || (DocumentKeyEnum = {}));
